<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text=" Informações Documentadas" />

      <Lynx-Button
        text="Cadastrar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="showModalPasta()"
      />

      <Lynx-Button
        text="atualizar pesquisa"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="listarPastas()"
      />
    </div>

    <treeselect
      :multiple="false"
      :options="lista_pesquisavel"
      placeholder="Selecione as arquivo..."
      v-model="arquivo_pesquisa"
    />
    <Lynx-Button
      :text="alfabetica ? 'Ordem de criação' : 'Ordem alfabética'"
      class="mt-3 mb-2 float-right"
      icon-size="3"
      size="small"
      @click.native="alfabetica = !alfabetica"
    />

    <v-row v-if="pastas">
      <v-col cols="12" class="w-full flex justify-between items-center">
        <p class="text-h4">Pastas</p>
        <!-- Adicione um botão de "Voltar" que lista todas as pastas -->
        <b-button
          v-if="pasta_selected.length > 0"
          @click.native="voltar()"
          type="is-info"
          class="mt-4"
        >
          <!-- Adicione um ícone de seta para trás (voltar) -->
          <v-icon style="color: white" left>mdi-arrow-left</v-icon> Voltar
        </b-button>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="2"
        lg="2"
        xl="2"
        v-for="(pasta, index) in pastas.pastas"
        :key="index"
      >
        <div @contextmenu="mostrarMenuContextual(pasta, $event)">
          <pasta
            :pasta="pasta"
            :arquivos="pastas.arquivos"
            :editavel="editavel"
            :pasta_id="past_editavel"
            @click.native="handleClick('folder', pasta)"
            @mousedown.native="handleMouseDown(pasta)"
            @mouseup.native="handleMouseUp"
          >
          </pasta>
          <v-list v-if="toastVisivel == pasta.id">
            <v-list-item style="font-size: 12px">
              <v-icon @click="toastVisivel = null">mdi-close</v-icon
              >{{ pasta.created_at | formatDateTimeToBr }}</v-list-item
            >
            <v-list-item style="font-size: 13px">
              {{ pasta.id }} - {{ pasta.nome }}</v-list-item
            >
            <v-list-item
              v-if="editavel != pasta.id"
              @click="()=>{editavel = pasta.id; past_editavel = null}"
              >Editar</v-list-item
            >
            <v-list-item v-else @click="()=>{editavel = null; past_editavel = pasta.id}">Renomar</v-list-item>

            <v-list-item @click="excluirPastas(pasta)">Excluir</v-list-item>
          </v-list>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="2"
        lg="2"
        xl="2"
        v-for="(arquivo, index) in pastas.arquivos"
        :key="index"
      >
        <div @contextmenu="mostrarMenuContextual(arquivo, $event)">
          <arquivos
            :arquivo="arquivo"
            :editavel="editavel"
            @click.native="handleClick('file', arquivo.id)"
            @mousedown.native="handleMouseDown(arquivo)"
            @mouseup.native="handleMouseUp"
          >
          </arquivos>

          <v-list v-if="toastVisivel == arquivo.id">
            <v-icon @click="toastVisivel = null">mdi-close</v-icon>

            {{ arquivo.id }} - {{ arquivo.nome_original }}
            <v-list-item
              v-if="editavel != arquivo.id"
              @click="editavel = arquivo.id"
              >Editar</v-list-item
            >
            <v-list-item v-else @click="editavel = null">Renomar</v-list-item>

            <v-list-item @click="excluirArquivo(arquivo)">Excluir</v-list-item>
          </v-list>
        </div>
      </v-col>
    </v-row>
    <Not-Found-Data v-else text="Nenhuma Pasta foi criada" />

    <b-modal :active.sync="modalPasta">
      <div class="bg-white pl-3 pr-3 pb-3">
        <br />
        <Lynx-Title text="Criar Pastas" />
        <div v-if="pasta_selected.length > 0">
          Pra dentro da Pasta :
          {{ pasta_selected[pasta_selected.length - 1].nome }}
        </div>

        <b-input id="nomearquivo" v-model="form.nome" />

        <div>
          <b-button
            @click.native="hideModalPasta()"
            type="is-danger"
            class="mt-4"
            >Cancelar</b-button
          >
          <b-button
            @click.native="createPasta()"
            type="is-primary"
            class="ml-4 mt-4"
            >Salvar</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import pasta from "./pasta";
import arquivos from "./arquivos";
import Treeselect from "@riophae/vue-treeselect";

import { mapGetters } from "vuex";
import { formatDateTimeToBr } from "@/utils/momentHelpers";

export default {
  components: { NotFoundData, pasta, arquivos, Treeselect },
  data() {
    return {
      form: { nome: "pasta1", subpasta_id: null },
      modalPasta: false,
      selectedFiles: [],
      loading: false,
      pasta_selected: [],
      isPressing: false,
      timer: null,
      preciona: 0,
      editavel: 0,
      arquivo_pesquisa: null,
      toastVisivel: false,
      alfabetica: false,
      past_editavel:0
    };
  },
  computed: {
    ...mapGetters(["getToken"]),

    pastas() {
      if (!this.alfabetica) {
        return this.$store.state.pasta.lista_pastas;
      }

      let pastas = [...this.$store.state.pasta.lista_pastas.pastas];

      pastas.sort((a, b) => {
        const nomeA = a.nome.toUpperCase();
        const nomeB = b.nome.toUpperCase();

        if (nomeA < nomeB) {
          return -1;
        }
        if (nomeA > nomeB) {
          return 1;
        }
        return 0;
      });

      const arquivos = this.$store.state.pasta.lista_pastas.arquivos;

      return { pastas, arquivos };
    },

    mensagem_alert() {
      return this.$store.state.pasta.mensagem_alert;
    },
    lista_pesquisavel() {
      let arquivos = Object.values(this.$store.state.pasta.lista_arquivos);
      let data = [];
      arquivos.forEach((element) => {
        data.push({ id: element.id, label: element.nome_original });
      });
      return data;
    },
  },
  mounted() {
    this.listarPastas();
  },
  watch: {
    arquivo_pesquisa() {
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${this.arquivo_pesquisa}/open?token=${this.getToken}`
      );
    },
  },
  filters: {
    formatDateTimeToBr,
  },
  methods: {
    voltar() {
      if (
        this.pasta_selected[this.pasta_selected.length - 1].subpasta_id == null
      ) {
        this.listarPastas();
        this.pasta_selected = [];
      } else {
        // console.log(this.pasta_selected)

        this.voltar_pasta();
      }
    },

    async listar_sub(value) {
      this.loading = true;
      this.pasta_selected.push(value);
      this.form.subpasta_id = value.id;

      await this.$store.dispatch("pasta/listar_subpastas", value.id);
      this.loading = false;
    },
    async voltar_pasta() {
      this.past_editavel= 0
      this.loading = true;
      let data = this.pasta_selected[this.pasta_selected.length - 1];
      if (this.pasta_selected.length - 1 == 0) {
        this.pasta_selected = [];
      }
      {
        this.pasta_selected = this.pasta_selected.filter(
          (element) => element.id !== data.id
        );
      }
      await this.$store.dispatch("pasta/listar_subpastas", data.subpasta_id);
      this.loading = false;
    },
    hideModalPasta() {
      this.modalPasta = false;
    },

    showModalPasta() {
      this.modalPasta = true;
      this.form.nome = null;
    },
    async createPasta() {
      this.loading = true;
      await this.$store
        .dispatch("pasta/create_pasta", this.form)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          this.hideModalPasta();
          this.loading = false;
        });
    },
    async listarPastas() {
      this.loading = true;
      this.form.subpasta_id = null;
      await this.$store.dispatch("pasta/listar_pastas");
      await this.$store.dispatch("pasta/listar_arquivos");

      this.loading = false;
    },
    handleClick(tipo, value) {
      // Ação ao clicar (clique duplo)
      // this.editavel  = 0
      if (this.editavel == 0) {
        this.preciona >= 2 ? 0 : (this.preciona += 1);
        if (this.preciona == 2) {
          this.preciona = 0;
          console.log("Clique Duplo!");

          if (tipo == "folder") {
            console.log(value);
            this.listar_sub(value);
          } else {
            window.open(
              `${process.env.VUE_APP_API_URL}/arquivos/${value}/open?token=${this.getToken}`
            );
          }
        }
      }
      console.log(this.preciona);
    },
    mostrarMenuContextual(parametro, event) {
      // Impedir o menu de contexto padrão do navegador
      event.preventDefault();
      this.editavel  = 0
      this.toastVisivel = parametro.id;
      // Exibir o menu contextual personalizado e usar o parâmetro
      this.menuContextualVisivel = true;
      console.log("Parâmetro:", parametro.nome);
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async handleMouseDown(value) {
      // Iniciar temporizador quando o botão é pressionado
      this.isPressing = true;
      // this.editavel  = 0
      await this.sleep(300);
      if (this.isPressing) {
        this.preciona = this.editavel == 0 ? 0 : -1;

        this.editavel =  await this.editavel == 0 ? value.id : 0;
        console.log("Botão Mantido Pressionado!");
      }
      this.preciona = this.preciona < 0 ? this.preciona : 0;
    },
    handleMouseUp() {
      this.isPressing = false;
      //   this.preciona= 0
    },

    async excluirPastas(pasta) {
      await this.$store.dispatch("pasta/delete_pasta", { id: pasta.id });
      if (this.pasta_selected.length == 0) {
        this.listarPastas();
        this.pasta_selected = [];
      } else {
        this.listar_sub(this.pasta_selected[this.pasta_selected.length - 1]);
      }
    },
    async excluirArquivo(arquivo) {
      await this.$store.dispatch("pasta/delete_arquivo", { id: arquivo.id });
      if (this.pasta_selected.length == 0) {
        this.listarPastas();
        // this.pasta_selected = [];
      } else {
        this.listar_sub(this.pasta_selected[this.pasta_selected.length - 1]);
      }
    },
  },
};
</script>

<style scoped>
</style>
  